import { d } from './chunk-6EFRS222.mjs';
import { forwardRef } from 'react';
import e from 'styled-components';
import { jsxs, jsx } from 'react/jsx-runtime';

var a=e.label`
  display: flex;
  align-items: center;
`,l=e(d)`
  color: var(--foreground-primary);
`,p=e(d)`
  padding-left: var(--spacing-x-small);
  color: var(--foreground-primary);
`,n=e.span`
  padding-left: var(--spacing-regular);
`;var i=forwardRef(({children:s,interaction:t,optional:b=!1,...d},f)=>jsxs(a,{...d,ref:f,children:[jsx(l,{weight:"bold",children:s}),b&&jsx(p,{children:"(optional)"}),t&&jsx(n,{children:t})]}));i.displayName="Label";var c=e(i)``;

export { c as a };
